import React from 'react';
import { FormattedMessage } from 'react-intl';

import AiIcon from '../../../../../components/AiIcon';

import { DOCUMENTATION_PATH } from '../../../../../constants/routes';

const INSTALL_GUIDE_URL = `${DOCUMENTATION_PATH}#/category1/Article%201`;

const binanceDownloadPlatforms = [
  {
    code: 'windows',
    icon: 'windows',
    name: 'files.atlasDownloadModal.platform.windows',
    subtitle: 'files.binanceModal.platform.windowsSubtitle',
    url: 'https://neural-app.s3.eu-west-1.amazonaws.com/binance/NeuralTradingBinance.win.exe',
    isLinux: false,
  },
  {
    code: 'mac',
    icon: 'mac',
    name: 'files.atlasDownloadModal.platform.mac',
    subtitle: 'files.binanceModal.platform.macSubtitle',
    url: 'https://neural-app.s3.eu-west-1.amazonaws.com/binance/NeuralTradingBinance.mac.dmg',
    isLinux: false,
  },
  {
    code: 'linux-arm64',
    icon: 'linux',
    name: 'files.binanceModal.platform.linuxArm64',
    subtitle: 'files.binanceModal.platform.linuxArm64Subtitle',
    url: 'https://neural-app.s3.eu-west-1.amazonaws.com/binance/NeuralTradingBinance.linux-arm64.AppImage',
    isLinux: true,
  },
  {
    code: 'linux-x86',
    icon: 'linux',
    name: 'files.binanceModal.platform.linuxX86',
    subtitle: 'files.binanceModal.platform.linuxX86Subtitle',
    url: 'https://neural-app.s3.eu-west-1.amazonaws.com/binance/NeuralTradingBinance.linux-x86_64.AppImage',
    isLinux: true,
  },
] as const;

const BinanceTabContent = () => (
  <>
    <div className="files-page__atlas-download-instructions">
      <p className="files-page__atlas-download-description">
        <FormattedMessage id="files.binanceModal.description" />
      </p>
      <a
        className="files-page__atlas-download-guide"
        href={INSTALL_GUIDE_URL}
        target="_blank"
        rel="noopener noreferrer"
      >
        <AiIcon name="download-installInstruction" />
        <FormattedMessage id="files.atlasDownloadModal.installGuide" />
      </a>
    </div>

    <div className="files-page__atlas-download-cards files-page__atlas-download-cards_cols-4">
      {binanceDownloadPlatforms.map(
        ({ code, icon, name, subtitle, url, isLinux }) => (
          <article
            key={code}
            className={`files-page__atlas-download-card${
              icon === 'mac' ? ' files-page__atlas-download-card_mac' : ''
            }${isLinux ? ' files-page__atlas-download-card_linux' : ''}`}
          >
            <AiIcon name={`download-${icon}`} />
            <h3 className="files-page__atlas-download-card-title">
              <FormattedMessage id={name} />
            </h3>
            <p className="files-page__atlas-download-card-subtitle">
              <FormattedMessage id={subtitle} />
            </p>
            <a
              className="files-page__atlas-download-card-btn"
              href={url}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <FormattedMessage id="files.atlasDownloadModal.download" />
            </a>
          </article>
        )
      )}
    </div>
  </>
);

export default BinanceTabContent;
